module.exports = __webpack_public_path__ + "static/media/payments.cecc657f.svg";